'use client'

import { RadioButton, RadioGroup } from '@graftcode/design-system'

import type { ServiceMapTimeRangeFilterValue } from '@apps/service-map/service-map.interface'
import { TIME_RANGE_FILTER_TEST_IDS } from '@apps/service-map/service-map-test-ids.const'

import type { ServiceMapTimeRangeFilterOption } from '../time-range.types'

import styles from '../TimeRangeFilter.module.scss'

export type TimeRangeFilterContentProps = {
  title: string
  pendingValue: ServiceMapTimeRangeFilterValue
  onPendingValueChange: (value: ServiceMapTimeRangeFilterValue) => void
  gridColumns: [readonly ServiceMapTimeRangeFilterOption[], readonly ServiceMapTimeRangeFilterOption[]]
}

export function TimeRangeFilterContent({
  title,
  pendingValue,
  onPendingValueChange,
  gridColumns,
}: TimeRangeFilterContentProps) {
  return (
    <div className={styles.section} data-testid={TIME_RANGE_FILTER_TEST_IDS.content}>
      <p className={styles.title}>{title}</p>
      <RadioGroup
        value={pendingValue}
        onChange={(next) => onPendingValueChange(next as ServiceMapTimeRangeFilterValue)}
        className={styles.radioGroup}
      >
        <div className={styles.radioGrid}>
          {gridColumns.map((column, columnIndex) => (
            // eslint-disable-next-line react-x/no-array-index-key -- two stable columns from splitOptionsIntoTwoColumns
            <div className={styles.column} key={`column-${columnIndex}`}>
              {column.map((option) => (
                <RadioButton key={option.value} value={option.value} label={option.label} />
              ))}
            </div>
          ))}
        </div>
      </RadioGroup>
    </div>
  )
}
